// removed by extract-text-webpack-plugin
module.exports = {"navSticky":"Header__navSticky","brand":"Header__brand"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = ./src/components/Header/Header.scss
// module chunks = 2